module.exports = __webpack_public_path__ + "static/media/Logo_negativo720.403936e1.png";